<template>
  <div id="reading">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建读本</el-button>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入读本的名称" v-model="search.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.enable">
            <el-option label="下架" value="0"></el-option>
            <el-option label="上架" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查 询</el-button>
          <el-button type="info" @click="doSearchCancel">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list-part">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            width="150"
            align="center"
            label="封面">
          <template slot-scope="scope">
            <img :src="scope.row.cover" style="border-radius:5px;width: 63px;height: 83px;">
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            label="读本名称"
            width="250">
        </el-table-column>
        <el-table-column
            prop="description"
            label="简介">
        </el-table-column>
        <el-table-column
            prop="moduleName"
            label="所属模块名"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            prop="ord"
            label="排序"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="是否可用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-value="1" inactive-value="0"
                       @change="onItemEnableChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="音频">
          <template slot-scope="scope">
            <el-button @click="playMp3(scope.row)" size="small" type="info">播放</el-button>
          </template>
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="消耗石头">
          <template slot-scope="scope">
            <span style="color: green " v-if="scope.row.payWith==='1'">{{ scope.row.price }} (绿色石头)</span>
            <span style="color: blue" v-if="scope.row.payWith==='2'">{{ scope.row.price }} (蓝色石头)</span>
            <span style="color: red" v-if="scope.row.payWith==='3'">{{ scope.row.price }} (红色石头)</span>
            <span style="color: #fafa03" v-if="scope.row.payWith==='4'">{{ scope.row.price }} (黄色石头)</span>
            <span style="color: #4EC9B0" v-if="scope.row.payWith==='5'">{{ scope.row.price }} (青色石头)</span>
            <span style="color: orange" v-if="scope.row.payWith==='6'">{{ scope.row.price }} (橙色石头)</span>
            <span style="color: #5c2699" v-if="scope.row.payWith==='7'">{{ scope.row.price }} (紫色石头)</span>
            <span v-if="scope.row.payWith===null || scope.row.payWith==='0'">免费</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            width="180"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="400"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="toDetail(scope.row)">内容详情</el-button>
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该读本吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
    <div class="dialog-part">
      <el-dialog
          :title="dialogText"
          :visible.sync="isEditorShow"
          center
          width="600px">
        <div>
          <el-form ref="readingRef" label-width="60px" size="medium">
            <el-form-item label="模块" :required="true">
              <el-cascader
                  clearable
                  v-model="selectModuleIds"
                  :options="appModuleTreeData"
                  :props="{ checkStrictly: false, value: 'id', label: 'name' }"
                  :show-all-levels="false"
                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>
            </el-form-item>
            <el-form-item
                label="标题" :required="true">
              <el-input v-model="reading.name" maxlength="7" :show-word-limit="true" placeholder="《院子里》"></el-input>
            </el-form-item>
            <el-form-item label="音频" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="audio/mpeg"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadMp3">
                  <el-button type="primary" v-text="reading.mp3Id===''?'上传音频':'更新音频'"></el-button>
                  <span class="upload-item-text" v-if="reading.mp3Id!==''">{{ reading.name }}.mp3</span>
                </el-upload>
              </div>
              <div class="form-des-text">
                MP3格式，大小不超过10M
              </div>
            </el-form-item>
            <el-form-item
                label="封面" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="image/jpeg,image/png,image/jpg"
                    :show-file-list="false"
                    :http-request="uploadReadingCover"
                    action="">
                  <div class="reading-cover">
                    <img v-if="reading.cover" :src="reading.cover" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，不超过1M
              </div>
            </el-form-item>
            <el-form-item label="上架">
              <el-switch v-model="reading.enable" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item
                label="顺序" :required="true">
              <el-input-number v-model="reading.ord" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item
                label="介绍" :required="true">
              <el-input v-model="reading.description" type="textarea"
                        rows="6"
                        maxlength="256"
                        show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="石头" :required="true">
              <el-select v-model="reading.payWith">
                <el-option value="0" label="免费"></el-option>
                <el-option value="1" label="绿色石头"></el-option>
                <el-option value="2" label="蓝色石头"></el-option>
                <el-option value="3" label="红色石头"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单价" :required="true" v-if="reading.payWith!==null&&reading.payWith!=='0'">
              <el-input-number v-model="reading.price" :min="1"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onEditorCancel" size="medium">取 消</el-button>
          <el-button type="primary" @click="onEditorConfirm" size="medium">提 交</el-button>
        </span>
      </el-dialog>
      <audio :src="targetPlayUrl" id="audio"></audio>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'

export default {
  data() {
    return {
      search: {
        name: '',
        enable: ''
      },
      reading: {
        id: '',
        name: '',
        cover: '',
        mp3Id: '',
        description: '',
        ord: '',
        mp3Name: '',
        payWith: '0',
        price: 0,
        enable: '1',
        moduleId: '0'
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      dialogText: '',
      isEditorShow: false,
      pagination: {
        pageSize: 1,
        total: 0,
        currentPage: 1,
        totalPage: 1
      },
      resultList: [],
      targetPlayUrl: ''
    }
  },
  methods: {
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    playMp3(item) {
      let mp3Id = item.mp3Id;
      api.getMp3PlayToken(mp3Id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.targetPlayUrl = result.data.url;
          let audio = document.getElementById('audio');
          if (audio) {
            this.$nextTick(function () {
              audio.play();
            });
          }
        } else {
          this.$message.error(result.msg)
        }
      });
    },
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    deleteItem(item) {
      api.deleteReading(item.id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    toDetail(item) {
      this.$router.push({
        path: '/word/reading-detail',
        query: {
          readingId: item.id
        }
      })
    },
    onEditorConfirm() {
      //检查数据
      if (this.reading.name === '') {
        return this.$message.error("请输入读本名.");
      }
      if (this.reading.mp3Id === '') {
        return this.$message.error("请上传读本名音频.");
      }
      if (this.reading.cover === '') {
        return this.$message.error("请上传读本封面.");
      }
      if (this.reading.description === '') {
        return this.$message.error("请填写读本简介.");
      }

      this.reading.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      //提交数据
      if (this.reading.id !== '') {
        //更新
        api.putReading(this.reading).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.onEditorCancel();
            this.listContent();
            this.$message.success(result.msg);
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        //上传
        api.postReading(this.reading).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.onEditorCancel();
            this.listContent();
            this.$message.success(result.msg);
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    onEditorCancel() {
      this.isEditorShow = false;
    },
    uploadMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: 'mp3上传成功.',
            type: 'success',
            center: true
          });
          this.reading.mp3Id = url;
          this.reading.mp3Name = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传mp3出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadReadingCover(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postReadingCover(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '读本封面上传成功.',
            type: 'success',
            center: true
          });
          this.reading.cover = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '读本封面上传出错',
          type: 'error',
          center: true
        })
      })
    },
    onItemEnableChange(item) {
      api.putReading(item).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success("更新状态成功.")
        } else {
          this.$message.error("更新状态失败.")
        }
      })
    },

    listContent() {
      api.listReading(this.pagination.currentPage, this.search).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    },
    doSearch() {
      this.pagination.currentPage = 1;
      this.listContent();
    },
    doSearchCancel() {
      this.search = {
        name: '',
        enable: ''
      };
      this.listContent();
    },

    findPath(tree, targetId, path = []) {
      for (let node of tree) {
        const currentPath = [...path, node.id];
        if (node.id === targetId) {
          return currentPath;
        }
        if (node.children && node.children.length > 0) {
          const result = this.findPath(node.children, targetId, currentPath);
          if (result) return result;
        }
      }
      return null;
    },

    showEditor(item) {
      this.selectModuleIds = [];
      // 清空对象信息
      this.reading = {
        id: '',
        name: '',
        cover: '',
        mp3Id: '',
        description: '',
        ord: '',
        mp3Name: '',
        payWith: '0',
        price: 0,
        enable: '1'
      }

      const setModulePath = () => {
        if (item) {
          this.reading = {
            ...this.reading, // 保留默认值
            ...item,         // 覆盖 item 中存在的属性
          };
          let path = this.findPath(this.appModuleTreeData, item.moduleId);
          this.selectModuleIds = path || []; // 如果找到就赋值，否则空数组
          this.dialogText = '编辑读本';
        } else {
          this.dialogText = '创建读本';
        }
        this.isEditorShow = true;
      }

      // 如果模块树数据不存在，则先加载
      if (this.appModuleTreeData.length === 0) {
        api.getAppModuleTree().then((result) => {
          if (result.code === api.SUCCESS_CODE) {
            this.appModuleTreeData = result.data;
            // 数据加载完成后，再设置模块路径
            setModulePath();
          }
        });
      } else {
        // 如果已有数据，直接设置
        setModulePath();
      }
    }
  },
  mounted() {
    this.listContent();
    this.getModuleTreeData();
  }
}
</script>
<style scoped>
.reading-cover {
  text-align: center;
  cursor: pointer;
  line-height: 200px;;
  margin-right: 20px;
  width: 200px;
  height: 200px;
  border-radius: 4px;
  border: #DCDFE6 dashed 2px;
}

.reading-cover img {
  width: 200px;
  height: 200px;
}

</style>
